export default __webpack_public_path__ + "static/media/ico-mail.0f792ef2.png";